<template>
    <b-icon-check2 v-if="status === 'FINISHED'" font-scale="1.5"></b-icon-check2>
</template>

<script>
import imagePath from '@/filters/image-path';
import {
  BIconCheck2,
} from 'bootstrap-vue';

export default {
  props: ['status'],
  components: {
    BIconCheck2,
  },
  filters: {
    imagePath,
  },
};
</script>

<style scoped lang="scss">
</style>
